import { axiosService } from "./axiosService";

const boxApi = {
    getAllBox(params) {
        const url = '/box';
        return axiosService.get(url, { params })
    },
    createBox(body) {
        const url = '/box';
        return axiosService.post(url, body)
    },
    updateBox(id, body) {
        const url = `/box/${id}`;
        return axiosService.put(url, body)
    },
    deleteBox(id) {
        const url = `/box/${id}`;
        return axiosService.delete(url)
    },
}

export default boxApi;